import { useState } from 'react';
import { createEmployee } from '../services/employeeService';
import { validateFields } from '../utils/employeeModalUtils';
import { checkUsernameExists } from '../services/employeeService';
import { FieldsList } from '../config/employeeFieldsConfig';

const useAddEmployeeForm = (handleClose) => {
  const [formData, setFormData] = useState({
    role: 'ADMIN',
    rowsPerPage: 20,
  });
  const [validationErrors, setValidationErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async () => {

    // Validate fields
    const errors = validateFields(formData, FieldsList, true); // 'true' indicates add mode
    setValidationErrors(errors);

    if (Object.keys(errors).length > 0) {
      return false;
    }

    // Check if the username already exists
    try {
      const usernameExists = await checkUsernameExists(formData.username);
      if (usernameExists) {
        // Add a validation error for the username field
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          username: 'Username already exists. Please enter a unique username.',
        }));
        return false;
      }
    } catch (error) {
      console.error('Error checking username uniqueness:', error);
      alert('An error occurred while checking username uniqueness.');
      return false;
    }

    // Proceed with form submission
    try {
      await createEmployee(formData);
      alert('Employee added successfully');
      return true;
    } catch (error) {
      console.error('Error adding employee:', error);
      alert('An error occurred while adding employee');
      return false;
    }
  };

  return {
    formData,
    handleInputChange,
    handleSubmit,
    validationErrors,
  };
};

export default useAddEmployeeForm;
